import { render, staticRenderFns } from "./huovOtaCode.vue?vue&type=template&id=4a0dfee2"
import script from "./huovOtaCode.vue?vue&type=script&lang=js"
export * from "./huovOtaCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports